// Dependent on accounting.js for number formatting

(function ($) {
  'use strict';

  var NAMESPACE = 'price-mask';

  $.fn.priceMask = function () {
    var delimiter = $('meta[name=currency_delimiter]').attr('content');
    var separator = $('meta[name=currency_separator]').attr('content');

    return this.each(function () {
      function _hasValue(value) {
        return value !== undefined && value !== '';
      }

      function _format(n) {
        var unformatted = accounting.unformat(n, separator);

        return accounting.formatNumber(unformatted, 2, delimiter, separator);
      }

      function onBlur(input) {
        var n = input.value;
        if (_hasValue(n)) {
          input.value = _format(n);
        }
      }

      $(this).on('blur.' + NAMESPACE, function () {
        onBlur(this);
      });
    });
  };

  $(function () {
    $('[data-plugin=' + NAMESPACE + ']').priceMask();
  });
})(jQuery);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/plugins/jquery.price-mask.js